import {createAction} from '@reduxjs/toolkit';
import {API_RESOURCES, createApiCreateAction, createApiReadAction, patchApiUpdateAction} from '../../../../../common/utils/api';

export const GET_PROJECT_INDEPENDENCE_DETAILS = 'Projects/GetById/Independence';
export const RESET_INDEPENDENCE = 'Projects/Independence/Reset';
export const PATCH_INDEPENDENCE_USERS = 'Project/Patch/Engagement/IndependenceUsers';
export const SET_CANVAS_ENGAGEMENT_ID = 'Project/Independence/Set/CanvasEngagement';
export const SET_INDEPENDENCE_FILTER = 'Project/Independence/Filter/Set';
export const POST_INDEPENDENCE_ENGAGEMENT_USERS = 'Project/Post/Independence/EngagementUsers';
export const UPDATE_USER_ENGAGMENT_INVITED_FLAG = 'Project/update/Independence/UserInvitedFlag';

export function getProjectIndependence(projectId) {
	return createApiReadAction(GET_PROJECT_INDEPENDENCE_DETAILS, {
		[API_RESOURCES.PROJECTS.PROJECTS]: projectId,
		[API_RESOURCES.PROJECTS.INDEPENDENCES]: undefined
	});
}

export const resetIndependence = createAction(RESET_INDEPENDENCE);

export function patchUserIndependenceStatus(projectId, engagementID, data) {
	return patchApiUpdateAction(
		PATCH_INDEPENDENCE_USERS,
		{
			[API_RESOURCES.PROJECTS.PROJECTS]: projectId,
			[API_RESOURCES.PROJECTS.ENGAGEMENTS]: engagementID,
			[API_RESOURCES.PROJECTS.INDEPENDENCEUSERS]: undefined
		},
		data
	);
}

export function createIndependenceEngagementUsers(projectId, engagementID, data) {
	return createApiCreateAction(
		POST_INDEPENDENCE_ENGAGEMENT_USERS,
		{
			[API_RESOURCES.PROJECTS.PROJECTS]: projectId,
			[API_RESOURCES.PROJECTS.ENGAGEMENTS]: engagementID,
			[API_RESOURCES.PROJECTS.ENGAGEMENTUSERS]: undefined
		},
		data
	);
}

export const setCanvasEngagementId = createAction(SET_CANVAS_ENGAGEMENT_ID);

export const setIndependenceFilter = createAction(SET_INDEPENDENCE_FILTER);

export const updateIsUsrEngmntInviteSentFlag = createAction(UPDATE_USER_ENGAGMENT_INVITED_FLAG);
